import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonAddFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.00044 2.49245C8.65704 0.835849 11.3429 0.835849 12.9995 2.49245C14.6561 4.14906 14.6561 6.83494 12.9995 8.49154C11.3429 10.1481 8.65704 10.1481 7.00044 8.49154C5.34384 6.83494 5.34384 4.14906 7.00044 2.49245ZM4.10462 12.7045C5.73203 11.7569 7.86705 11.241 10 11.241C11.6283 11.241 13.2474 11.5426 14.6413 12.0995C14.9031 12.2041 15.0841 12.4467 15.1099 12.7275C15.1356 13.0082 15.0018 13.2797 14.7634 13.4302C13.5033 14.2256 12.9873 15.2545 12.8257 16.2162C12.659 17.2083 12.8689 18.1491 13.1011 18.6847C13.2016 18.9165 13.1786 19.1833 13.04 19.3946C12.9014 19.6058 12.6657 19.733 12.413 19.733H3C2.03379 19.733 1.25 18.9492 1.25 17.983V16.983C1.25 15.1017 2.48403 13.6481 4.10462 12.7045Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17 15V19M19 17H15M17 22C14.239 22 12 19.762 12 17C12 14.296 14.3 11.997 17.004 12C19.764 12.002 22 14.24 22 17C22 19.761 19.762 22 17 22Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgPersonAddFilled);
export default ForwardRef;
